// Русский словарь panel'и. Ключи — единый источник правды,
// см. src/i18n/index.tsx для типа DictKey.
//
// Plural-ключи: суффиксы .one/.few/.many/.other согласно Intl.PluralRules
// и шаблон `{n}` подставляется автоматически в t.n(...).

export const ru = {
  // Common
  'common.loading': 'Загрузка…',
  'common.cancel': 'Отмена',
  'common.save': 'Сохранить',
  'common.create': 'Создать',
  'common.delete': 'Удалить',
  'common.close': 'Закрыть',
  'common.edit': 'Редактировать',
  'common.copy': 'копировать',
  'common.copied': 'скопировано',
  'common.error': 'Ошибка',
  'common.actions': 'Действия',
  'common.from': 'С',
  'common.to': 'По',
  'common.yes': 'Да',
  'common.no': 'Нет',
  'common.search': 'Поиск',
  'common.unknown': 'неизвестно',
  'common.never': 'никогда',
  'common.empty': 'Пусто',
  'common.notLoaded': 'Сессия не загружена',
  'common.reset': 'Сбросить',
  'offline.banner': 'Нет подключения к сети. Показываем последний снимок диалогов.',
  'desktop.update.available': 'Доступна версия {version} приложения',
  'desktop.update.install': 'Обновить',
  'desktop.update.installing': 'Обновление…',
  'common.unknownError': 'Неизвестная ошибка',
  'common.errorPrefix': 'Ошибка',
  'common.readonly': 'только просмотр',
  'common.hide': 'Скрыть',

  // Nav
  'nav.brand': 'Anexica',
  'nav.conversations': 'Диалоги',
  'nav.liveVisitors': 'На сайте',
  'nav.analytics': 'Аналитика',
  'nav.cannedResponses': 'Шаблоны',
  'nav.exports': 'Экспорт',
  'nav.sites': 'Сайты',
  'nav.webhooks': 'Webhooks',
  'nav.audit': 'Аудит',
  'nav.reports': 'Отчёты',
  'nav.billing': 'Тариф и оплата',
  'nav.settings': 'Настройки',
  'liveVisitors.title': 'Кто сейчас на сайте',
  'liveVisitors.hint': 'Визитёры, находящиеся на сайте прямо сейчас. Обновляется каждые несколько секунд.',
  'liveVisitors.counts.now': 'Сейчас на сайте',
  'liveVisitors.counts.last5min': 'За 5 минут',
  'liveVisitors.counts.lastHour': 'За час',
  'liveVisitors.counts.today': 'Сегодня',
  'liveVisitors.empty': 'Сейчас на сайте никого нет',
  'liveVisitors.anonymous': 'Аноним',
  'liveVisitors.writeFirst': 'Написать первым',
  'liveVisitors.openConversation': 'Открыть чат',
  'liveVisitors.outreachPlaceholder': 'Напишите первое сообщение…',
  'liveVisitors.send': 'Отправить',
  'liveVisitors.sending': 'Отправка…',
  'liveVisitors.outreachError': 'Не удалось отправить, попробуйте ещё раз',
  'nav.logout': 'Выйти',
  'theme.toggle': 'Сменить тему',
  'theme.light': 'Светлая тема',
  'theme.dark': 'Тёмная тема',

  // Статус оператора (ANX-071)
  'status.label': 'Статус',
  'status.online': 'В сети',
  'status.away': 'Отошёл',
  'status.busy': 'Занят',
  'status.offline': 'Не в сети',

  // Auth / Login
  'auth.title': 'Вход в Anexica',
  'auth.email': 'Email',
  'auth.password': 'Пароль',
  'auth.tenant': 'Организация',
  'auth.tenantHint': 'Слаг организации — из приглашения',
  'auth.forgotPassword': 'Забыли пароль?',
  'auth.sessionExpired': 'Сессия истекла. Войдите снова.',
  'auth.backToLogin': '← Вернуться ко входу',
  'auth.submit': 'Войти',
  'auth.submitting': 'Вход…',
  'auth.error.invalidCredentials': 'Неверный email, пароль или организация',
  'auth.error.tenantSuspended': 'Тенант приостановлен — обратитесь к админу',
  'auth.error.forbidden': 'Доступ запрещён',
  'auth.error.rateLimited': 'Слишком много попыток, подождите минуту',
  'auth.error.network': 'Проблемы с сетью — проверьте соединение',
  'auth.error.invalidPayload': 'Заполните все поля',
  'auth.error.generic': 'Не удалось войти',
  // ANX-102 — восстановление пароля
  'auth.forgot.title': 'Восстановление пароля',
  'auth.forgot.subtitle': 'Укажите email и организацию — пришлём ссылку для сброса пароля.',
  'auth.forgot.submit': 'Отправить ссылку',
  'auth.forgot.submitting': 'Отправляем…',
  'auth.forgot.sent':
    'Если такая учётная запись существует, мы отправили ссылку для сброса на email. Проверьте почту (и папку «Спам»).',
  'auth.reset.title': 'Сброс пароля',
  'auth.reset.subtitle': 'Придумайте новый пароль для вашей учётной записи.',
  'auth.reset.password': 'Новый пароль',
  'auth.reset.confirm': 'Повторите пароль',
  'auth.reset.submit': 'Сохранить пароль',
  'auth.reset.submitting': 'Сохраняем…',
  'auth.reset.success': 'Пароль изменён. Теперь войдите с новым паролем.',
  'auth.reset.toLogin': 'Войти',
  'auth.reset.mismatch': 'Пароли не совпадают',
  'auth.reset.tooShort': 'Пароль должен быть не короче 8 символов',
  'auth.reset.invalidToken': 'Ссылка недействительна или истекла.',
  'auth.reset.requestNew': 'Запросить новую ссылку',

  // Conversations list
  'conversations.title': 'Диалоги',
  'conversations.empty': 'Нет диалогов',
  'conversations.emptyOpen': 'Нет открытых диалогов.',
  'conversations.emptyClosed': 'Нет закрытых диалогов.',
  'conversations.filter.all': 'Все',
  'conversations.filter.open': 'Открытые',
  'conversations.filter.closed': 'Закрытые',
  'conversations.filter.mine': 'Мои',
  'conversations.lastMessage': 'Последнее сообщение',
  'conversations.assignedTo': 'Назначен оператор',
  'conversations.unassigned': 'Не назначен',
  'conversations.csat.all': 'Все',
  'conversations.csat.rated': 'Оценка визитёра',
  'conversations.csat.positive': 'Положительная оценка',
  'conversations.csat.negative': 'Отрицательная оценка',
  // ANX-047 — таб назначения в rail
  'conversations.assignFilter.all': 'Все',
  'conversations.assignFilter.me': 'Мои',
  'conversations.assignFilter.unassigned': 'Не назначены',
  'conversations.openInView': 'Открыть',
  'conversations.loadError': 'Не удалось загрузить диалоги',
  // ANX-042 — поиск по диалогам
  'conversations.searchPlaceholder': 'Поиск по имени, email, сообщениям…',
  'conversations.searchClear': 'Очистить поиск',
  'conversations.emptySearch': 'Ничего не найдено',
  // ANX-043 — теги диалогов
  'tags.add': 'Добавить тег',
  'tags.removeChip': 'Убрать тег',
  'tags.empty': 'Нет тегов',
  'tags.searchOrCreate': 'Найти или создать тег…',
  'tags.create': 'Создать',
  'tags.filterTitle': 'Фильтр по тегу',
  'tags.filterAll': 'Все',
  'tags.adminTitle': 'Теги диалогов',
  'tags.adminHint': 'Категории для быстрой группировки переписок — продажи, поддержка, VIP, спам, на потом.',
  'tags.namePlaceholder': 'Имя тега',
  'tags.colorLabel': 'Цвет',
  'tags.confirmDelete': 'Удалить тег',
  'tags.error.nameRequired': 'Укажите имя тега',
  'tags.error.nameTaken': 'Такой тег уже есть',
  'departments.adminTitle': 'Отделы',
  'departments.adminHint': 'Команды, которые визитёр выбирает в pre-chat форме (продажи, поддержка, биллинг). Используются для маршрутизации.',
  'departments.empty': 'Отделов пока нет',
  'departments.namePlaceholder': 'Название отдела',
  'departments.confirmDelete': 'Удалить отдел',
  'departments.error.nameRequired': 'Укажите название отдела',
  'departments.error.nameTaken': 'Такой отдел уже есть',
  'conversations.status.open': 'Открыт',
  'conversations.status.closed': 'Закрыт',
  'conversations.loadingAria': 'Загрузка диалогов',
  'conversations.visitor.fallback': 'Гость',
  'conversations.visitor.noContacts': 'Контакты не оставлены',
  'conversations.visitor.copy': 'Скопировать',
  'conversations.visitor.copied': 'Скопировано',
  'conversations.visitor.email': 'Email',
  'conversations.visitor.phone': 'Телефон',

  // Inbox placeholder
  'inbox.empty.title': 'Выберите диалог',
  'inbox.empty.hint': 'Слева — список ваших чатов. Кликните по любому, чтобы открыть.',
  'inbox.empty.noneOpen': 'Открытых диалогов пока нет — но мы вас уведомим, когда придёт новый.',

  // Signup
  'signup.title': 'Регистрация в Anexica',
  'signup.subtitle': 'Создайте аккаунт за минуту — карта не нужна.',
  'signup.email': 'Email',
  'signup.password': 'Пароль',
  'signup.passwordHint': 'Минимум 8 символов',
  'signup.tenantName': 'Название компании',
  'signup.tenantNameHint': 'Например, «Acme Corp» — пригодится в адресе и интерфейсе',
  'signup.submit': 'Создать аккаунт',
  'signup.submitting': 'Создаём аккаунт…',
  'signup.loginLink': 'Уже есть аккаунт? Войти',
  'signup.error.invalidPayload': 'Заполните все поля, пароль ≥ 8 символов',
  'signup.error.rateLimited': 'Слишком много регистраций с этого IP, подождите час',
  'signup.error.slugTaken': 'Не удалось создать аккаунт, попробуйте ещё раз',
  'signup.error.network': 'Проблемы с сетью — проверьте соединение',
  'signup.error.generic': 'Не удалось создать аккаунт',
  'signup.error.captchaRequired': 'Подтвердите, что вы не робот',
  'signup.error.captchaFailed': 'Проверка captcha не прошла, попробуйте ещё раз',
  'signup.error.captchaUnavailable': 'Сервис captcha недоступен, попробуйте позже',
  'signup.error.consentRequired': 'Подтвердите согласие на обработку персональных данных',
  'signup.consent.label': 'Я согласен(на) на обработку моих персональных данных, ознакомлен(а) с',
  'signup.consent.policy': 'политикой конфиденциальности',
  'signup.consent.glue': ' и принимаю ',
  'signup.consent.terms': 'условия использования',

  // Onboarding
  'onboarding.title': 'Подключите Anexica к сайту',
  'onboarding.subtitle': 'Три шага — и вы получите первое сообщение прямо здесь.',
  'onboarding.step1.title': 'Вставьте сниппет на сайт',
  'onboarding.step1.hint': 'Скопируйте код и добавьте перед закрывающим </body> на любой странице.',
  'onboarding.step1.copy': 'Скопировать код',
  'onboarding.step1.copied': 'Скопировано!',
  'onboarding.step2.title': 'Откройте сайт в браузере',
  'onboarding.step2.hint': 'Виджет появится в углу — кликните по нему и напишите тестовое сообщение.',
  'onboarding.step3.title': 'Получите первое сообщение здесь',
  'onboarding.step3.hint': 'Как только сообщение придёт, мы отметим этот шаг и откроем диалог.',
  'onboarding.step3.waiting': 'Ждём первое сообщение…',
  'onboarding.step3.done': 'Сообщение получено! Откроем диалог.',
  'onboarding.allDone': 'Готово! Anexica подключена.',
  'onboarding.goToInbox': 'Перейти к диалогам',
  'onboarding.skip': 'Пропустить — я сделаю это позже',

  // Conversation view
  'conversation.title': 'Диалог',
  'conversation.send': 'Отправить',
  'conversation.placeholder': 'Ответ оператора (или /шаблон)…',
  'conversation.uploadingPlaceholder': 'Загрузка…',
  'conversation.assignToMe': 'Взять',
  // ANX-047 — assignment-control
  'conversation.assigned.me': 'Назначено мне',
  'conversation.assigned.other': 'Назначено',
  'conversation.assigned.none': 'Не назначено',
  'conversation.assign.takeMe': 'Взять себе',
  'conversation.assign.unassign': 'Снять назначение',
  'conversation.close': 'Закрыть диалог',
  'conversation.closed': 'Закрыт',
  'conversation.reopen': 'Открыть заново',
  'conversation.attachFile': 'Прикрепить файл',
  'conversation.emoji': 'Эмодзи',
  'conversation.dropHint': 'Отпустите файл, чтобы прикрепить',
  'conversation.search.open': 'Поиск в диалоге',
  'conversation.search.placeholder': 'Поиск в диалоге…',
  'conversation.search.prev': 'Предыдущее совпадение',
  'conversation.search.next': 'Следующее совпадение',
  'conversation.search.close': 'Закрыть поиск',
  'conversation.search.noResults': 'нет совпадений',
  'conversation.visitorTyping': 'посетитель печатает…',
  'conversation.visitorTypingAria': 'посетитель печатает',
  'conversation.csat.label': 'Оценка визитёра:',
  'conversation.department.label': 'Отдел:',
  'conversation.note.modeLabel': 'Режим сообщения',
  'conversation.note.modeReply': 'Ответ',
  'conversation.note.modeNote': 'Заметка',
  'conversation.note.hint': 'видна только команде',
  'conversation.note.placeholder': 'Внутренняя заметка… @имя — упомянуть коллегу',
  'conversation.note.send': 'Сохранить',
  'conversation.note.author': 'Оператор',
  'conversation.note.badge': '· внутренняя заметка',
  'conversation.note.error': 'Не удалось сохранить заметку',
  'context.title': 'О визитёре',
  'context.page': 'Текущая страница',
  'context.referrer': 'Источник',
  'context.location': 'Локация',
  'context.device': 'Устройство',
  'context.screen': 'Экран',
  'context.language': 'Язык',
  'context.attributes': 'Атрибуты',
  'context.history': 'Прошлые обращения',
  'context.noHistory': 'Это первое обращение',
  'conversation.online': 'онлайн',
  'conversation.connecting': 'подключение…',
  'conversation.offline': 'нет связи',
  'conversation.notFound': 'Диалог не найден',
  'conversation.loadError': 'Не удалось загрузить диалог',
  'conversation.sendError': 'не удалось отправить',
  'conversation.uploadError': 'не удалось загрузить',
  'conversation.uploadTooLarge': 'Файл слишком большой',
  'conversation.sending': 'отправка…',
  'conversation.failed': 'не отправлено',
  'conversation.read': 'Прочитано',
  'conversation.delivered': 'Доставлено',
  'conversation.reply': 'Ответить',
  'conversation.reply.you': 'Вы',
  'conversation.reply.visitor': 'Гость',
  'conversation.reply.unavailable': 'сообщение недоступно',
  'conversation.reply.cancel': 'Отменить ответ',

  // Analytics
  'analytics.title': 'Аналитика',
  'analytics.openConversations': 'Открытых диалогов',
  'analytics.openConversationsHint': 'сейчас',
  'analytics.firstResponseP50': 'Первый ответ p50',
  'analytics.firstResponseP95': 'Первый ответ p95',
  'analytics.avgResponse': 'Среднее время ответа',
  'analytics.chatsPerDay': 'Диалогов в день',
  'analytics.heatmap.title': 'Часы нагрузки',
  'analytics.heatmap.hint': 'Новые диалоги по дням недели и часам (в вашей таймзоне). Темнее — больше обращений.',
  'analytics.activeOperators': 'Активные операторы',
  'analytics.operator': 'Оператор',
  'analytics.chatsCount': 'Диалогов',
  'analytics.csat': 'CSAT',
  'analytics.noData': 'Нет данных за выбранный период',
  'analytics.error': 'Не удалось загрузить аналитику',
  'analytics.site': 'Сайт',
  'analytics.siteAll': 'Все сайты',
  'analytics.noOperatorsForPeriod': 'За выбранный период никто не отвечал.',

  // Canned responses
  'canned.title': 'Шаблоны ответов',
  'canned.create': '+ Новый шаблон',
  'canned.edit': 'Изменить',
  'canned.editTitle': 'Изменить шаблон',
  'canned.newTitle': 'Новый шаблон',
  'canned.delete': 'Удалить',
  'canned.shortcut': 'Shortcut',
  'canned.shortcutHint': 'Shortcut (опционально, начинается с /)',
  'canned.body': 'Текст',
  'canned.bodyHint': 'Будет вставлен в поле ввода при выборе.',
  'canned.titleField': 'Название',
  'canned.scope': 'Scope',
  'canned.scope.personal': 'личный',
  'canned.scope.shared': 'общий',
  'canned.scope.personalLong': 'Личный (только вы)',
  'canned.scope.sharedLong': 'Общий (все операторы)',
  'canned.scope.sharedHint': 'Виден всем операторам тенанта',
  'canned.empty': 'Пока нет шаблонов. Создайте первый — он появится здесь.',
  'canned.shortcutTaken': 'Такое сокращение уже используется',
  'canned.confirmDelete': 'Удалить шаблон?',
  'canned.saveError': 'Ошибка сохранения',
  'canned.loadError': 'Не удалось загрузить шаблоны',

  // Exports
  'exports.title': 'Экспорт чатов',
  'exports.intro': 'Выгрузка сообщений в CSV или JSON. Файл живёт 24 часа.',
  'exports.create': '+ Создать экспорт',
  'exports.newTitle': 'Новый экспорт',
  'exports.format': 'Формат',
  'exports.format.csv': 'CSV',
  'exports.format.json': 'JSON',
  'exports.range.from': 'С даты',
  'exports.range.to': 'По дату',
  'exports.site': 'Сайт',
  'exports.siteAll': 'Все сайты',
  'exports.status.queued': 'в очереди',
  'exports.status.processing': 'выгружается',
  'exports.status.ready': 'готов',
  'exports.status.failed': 'ошибка',
  'exports.status.expired': 'истёк',
  'exports.column.created': 'Создан',
  'exports.column.format': 'Формат',
  'exports.column.status': 'Статус',
  'exports.column.rows': 'Сообщений',
  'exports.column.size': 'Размер',
  'exports.download': 'Скачать',
  'exports.empty': 'Пока нет экспортов.',
  'exports.emptyHintAdmin': 'Нажмите кнопку выше, чтобы создать первый.',
  'exports.emptyHintOperator': 'Только admin может создавать экспорты.',
  'exports.creating': 'Создаём…',
  'exports.submitCreate': 'Создать',
  'exports.createError': 'Не удалось создать экспорт',
  'exports.tooManyActive': 'Слишком много активных экспортов',
  'exports.refreshHint': 'Список обновляется автоматически',

  // Sites
  'sites.title': 'Сайты',
  'sites.create': 'Создать',
  'sites.name': 'Название',
  'sites.domain': 'Домен',
  'sites.domainOptional': 'Домен (опц.)',
  'sites.widgetKey': 'Widget key',
  'sites.copyKey': 'копировать',
  'sites.copied': 'скопировано',
  'sites.edit': 'Изменить',
  'sites.save': 'Сохранить',
  'sites.cancel': 'Отмена',
  'sites.pause': 'Приостановить',
  'sites.resume': 'Возобновить',
  'sites.delete': 'Удалить',
  'sites.confirmDelete': 'Удалить сайт «{name}»?',
  'sites.theme.color': 'Цвет акцента',
  'sites.theme.greeting': 'Приветствие',
  'sites.theme.greetingPlaceholder': 'По умолчанию: «Здравствуйте! 👋»',
  'sites.theme.right': 'Справа',
  'sites.theme.left': 'Слева',
  'sites.theme.save': 'Сохранить виджет',
  // ANX-050 — email-транскрипт
  'sites.transcripts.title': 'Email-транскрипт visitor’у',
  'sites.followUp.title': 'Follow-up email на брошенный диалог',
  'sites.followUp.hint': 'Если визитёр ушёл оффлайн, а оператор ответил — визитёру (при наличии email и согласия) уйдёт письмо «вам ответили». Одно письмо на диалог.',
  // ANX-065 — Telegram-канал.
  'sites.telegram.title': 'Telegram-бот',
  'sites.telegram.hint': 'Подключите бота (@BotFather → токен) — входящие из Telegram попадут в этот же инбокс, ответы уйдут обратно в бота.',
  'sites.telegram.connected': 'Подключён',
  'sites.telegram.connect': 'Подключить',
  'sites.telegram.connecting': 'Подключение…',
  'sites.telegram.disconnect': 'Отключить',
  'sites.telegram.tokenPlaceholder': 'Токен бота от @BotFather',
  'conversations.channel.telegram': 'Диалог из Telegram',
  'sites.transcripts.hint': 'После закрытия диалога visitor получает копию переписки на свой email, если оставил его и подтвердил opt-in в шапке виджета.',
  'conversation.transcript.sendToMe': 'Прислать копию мне',
  'conversation.transcript.sending': 'Отправляем…',
  'conversation.transcript.sent': 'Отправлено',
  'conversation.transcript.error': 'Не удалось отправить',
  'sites.empty': 'Нет сайтов',
  'sites.saveError': 'Не удалось сохранить сайт',
  'sites.saving': 'Сохраняем…',
  'sites.saved': 'Сохранено',
  'sites.loadError': 'Не удалось загрузить сайты',
  // ANX-051 — pro-active trigger
  'sites.proactive.title': 'Авто-приветствие в виджете',
  'sites.proactive.hint': 'Через заданное время виджет сам открывается с приветствием от лица оператора. Полезно для конверсии; visitor может закрыть, и до конца сессии триггер не повторится.',
  'sites.proactive.enabledLabel': 'Включить авто-открытие',
  'sites.proactive.delayLabel': 'Задержка, секунд',
  'sites.proactive.messageLabel': 'Текст приветствия',
  'sites.proactive.messagePlaceholder': 'Здравствуйте! Чем помочь?',
  'sites.proactive.mobileLabel': 'Показывать также на мобильных (по умолчанию выключено — full-screen виджет всплывает поверх контента и может раздражать)',
  'sites.proactive.delayError': 'Задержка должна быть от 5 до 3600 секунд',
  'sites.proactive.messageError': 'Сообщение не должно превышать 280 символов',

  // ANX-061 — часы работы + offline-режим
  'sites.office.title': 'Часы работы',
  'sites.office.hint': 'Вне рабочих часов виджет показывает offline-сообщение и собирает email. «Сейчас рабочее время» вычисляется по таймзоне сайта.',
  'sites.office.enabledLabel': 'Включить часы работы',
  'sites.office.tzLabel': 'Таймзона (IANA)',
  'sites.office.tzError': 'Укажите таймзону, например Europe/Moscow',
  'sites.office.intervalError': 'Начало рабочего дня должно быть раньше конца',
  'sites.office.messageLabel': 'Offline-сообщение',
  'sites.office.messagePlaceholder': 'Сейчас мы не на связи. Оставьте email — ответим в рабочее время.',
  'sites.office.messageError': 'Сообщение не должно превышать 280 символов',
  'sites.office.collectEmailLabel': 'Собирать email visitor’а вне рабочих часов',
  'sites.prechat.title': 'Pre-chat форма',
  'sites.prechat.hint': 'Спрашивать данные у визитёра до старта чата. По умолчанию выключено.',
  'sites.prechat.enabledLabel': 'Показывать форму перед началом диалога',
  'sites.prechat.field.name': 'Имя',
  'sites.prechat.field.email': 'Email',
  'sites.prechat.field.phone': 'Телефон',
  'sites.prechat.field.question': 'Вопрос',
  'sites.prechat.requiredLabel': 'Обязательно',
  'sites.prechat.departmentLabel': 'Дать визитёру выбрать отдел',
  'sites.prechat.noDepartments': 'Отделы не настроены. Создайте их в Настройках → Отделы, чтобы включить выбор.',
  'sites.prechat.introLabel': 'Текст-вступление',
  'sites.prechat.introPlaceholder': 'Показывается над формой',
  'sites.prechat.introError': 'Вступление не должно превышать 280 символов',
  'sites.office.fromLabel': 'с',
  'sites.office.toLabel': 'до',
  'sites.office.day.mon': 'Понедельник',
  'sites.office.day.tue': 'Вторник',
  'sites.office.day.wed': 'Среда',
  'sites.office.day.thu': 'Четверг',
  'sites.office.day.fri': 'Пятница',
  'sites.office.day.sat': 'Суббота',
  'sites.office.day.sun': 'Воскресенье',

  // Webhooks
  'webhooks.title': 'Webhooks',
  'webhooks.create': 'Создать webhook',
  'webhooks.name': 'Название',
  'webhooks.url': 'URL',
  'webhooks.events': 'События',
  'webhooks.secret': 'Секрет',
  'webhooks.secretBanner': 'Secret для endpoint {id} (показан один раз!):',
  'webhooks.active': 'Активен',
  'webhooks.inactive': 'Отключён',
  'webhooks.pause': 'Приостановить',
  'webhooks.resume': 'Возобновить',
  'webhooks.delete': 'Удалить',
  'webhooks.confirmDelete': 'Удалить webhook «{name}»?',
  'webhooks.empty': 'Нет webhook endpoints',
  'webhooks.saveError': 'Не удалось сохранить webhook',
  'webhooks.loadError': 'Не удалось загрузить webhooks',
  'webhooks.event.messageNew': 'message.new',
  'webhooks.event.conversationAssigned': 'conversation.assigned',
  'webhooks.event.conversationClosed': 'conversation.closed',

  // Settings
  'settings.title': 'Настройки',
  'settings.name': 'Имя',
  'settings.email': 'Email',
  'settings.role': 'Роль',
  'settings.operatorId': 'ID оператора',
  'settings.tenantId': 'ID тенанта',
  'settings.passwordHint': 'Смена пароля доступна через флоу «Забыли пароль» на странице входа.',
  'settings.language': 'Язык интерфейса',
  'settings.language.ru': 'Русский',
  'settings.language.en': 'English',
  'settings.push.title': 'Push-уведомления',
  'settings.push.unsupported': 'Браузер не поддерживает push-уведомления',
  'settings.push.serverDisabled': 'Push-уведомления отключены на сервере',
  'settings.push.permissionDenied': 'Push заблокирован в настройках браузера — разрешите вручную',
  'settings.push.subscribed': 'Push-уведомления включены на этом устройстве',
  'settings.push.subscribedHint': 'Новые сообщения от посетителей будут приходить даже когда вкладка закрыта',
  'settings.push.idle': 'Push-уведомления выключены',
  'settings.push.enable': 'Включить push',
  'settings.push.disable': 'Отключить push',
  'settings.push.working': 'Применяем…',
  'settings.push.failed': 'Не удалось изменить настройку push',

  // Security / 2FA (passkey, ANX-013)
  'security.section.title': 'Двухфакторная аутентификация',
  'security.section.intro': 'Защитите вход вашим устройством — Touch ID, Face ID, Windows Hello или аппаратным ключом.',
  'security.passkeys.heading': 'Зарегистрированные passkey',
  'security.passkeys.empty': 'Нет ни одного passkey. Добавьте первый — мы выпустим резервные коды.',
  'security.passkey.register': 'Зарегистрировать passkey',
  'security.passkey.registering': 'Подтвердите на устройстве…',
  'security.passkey.namePrompt': 'Название устройства (например, «MacBook»):',
  'security.passkey.defaultName': 'Мой passkey',
  'security.passkey.created': 'Добавлен:',
  'security.passkey.lastUsed': 'Последний вход:',
  'security.passkey.delete': 'Удалить',
  'security.passkey.confirmDelete': 'Удалить этот passkey? Если он последний, у вас должны остаться резервные коды.',
  'security.passkey.cannotDeleteLast': 'Этот passkey последний, а tenant требует MFA. Сначала выключите политику или добавьте ещё один passkey.',
  'security.passkey.unsupported': 'Этот браузер не поддерживает passkey (WebAuthn).',
  'security.passkey.disabled': 'Passkey временно недоступны (WEBAUTHN_RPID не настроен на сервере).',
  'security.passkey.error': 'Не удалось зарегистрировать passkey',
  'security.recovery.heading': 'Резервные коды',
  'security.recovery.intro': 'Используйте, если потеряете все устройства. Каждый код работает один раз.',
  'security.recovery.regenerate': 'Сгенерировать новые',
  'security.recovery.regenerating': 'Создаём…',
  'security.recovery.warning': 'Сохраните коды сейчас — после закрытия окна вы их больше не увидите.',
  'security.recovery.copy': 'Скопировать',
  'security.recovery.copied': 'Скопировано',
  'security.recovery.done': 'Готово',
  'security.recovery.error': 'Не удалось создать резервные коды',
  'security.recovery.previewTitle': 'Ваши новые резервные коды',

  // Tenant security policy (admin only)
  'security.policy.heading': 'Политика безопасности tenant',
  'security.policy.requireMfa': 'Требовать passkey у всех операторов',
  'security.policy.requireMfaHint': 'При включении операторы без passkey будут вынуждены зарегистрировать его при следующем входе.',
  'security.policy.saving': 'Сохраняем…',
  'security.policy.saveError': 'Не удалось обновить политику',
  'security.policy.adminOnly': 'Доступно только администраторам tenant',
  // ANX-071: лимит нагрузки оператора
  'security.policy.maxConcurrent': 'Лимит одновременных диалогов на оператора',
  'security.policy.maxConcurrentHint': '0 — без лимита. При достижении оператор перестаёт получать авто-назначения (ANX-070).',
  'security.policy.routing': 'Авто-назначение новых диалогов',
  'security.policy.routing.off': 'Выключено (вручную)',
  'security.policy.routing.roundRobin': 'По кругу (round-robin)',
  'security.policy.routing.leastBusy': 'Наименее загруженному',
  'security.policy.routingHint': 'Новые диалоги авто-назначаются свободному online-оператору (с учётом лимита нагрузки). Нет доступных → диалог в общем пуле.',
  'security.policy.sla': 'SLA первого ответа (минуты)',
  'security.policy.slaHint': '0 — выкл. Диалоги, ждущие ответа дольше порога, шлют web-push назначенному оператору (или админам).',
  'security.policy.followUpDelay': 'Задержка follow-up email (минуты)',
  'security.policy.followUpDelayHint': 'Сколько ждать после ответа оператора перед отправкой follow-up письма брошенному визитёру. Включается на уровне сайта.',
  'security.policy.slaRespectOfficeHours': 'Не слать алерты вне рабочих часов сайта',
  // ANX-068 — плановые отчёты.
  'reports.title': 'Отчёты',
  'reports.subtitle': 'Архив периодических дайджестов по метрикам диалогов.',
  'reports.adminOnly': 'Отчёты доступны только администраторам.',
  'reports.empty': 'Отчётов пока нет',
  'reports.emptyHint': 'Включите расписание в настройках — первый отчёт придёт по итогам периода.',
  'reports.selectHint': 'Выберите отчёт слева, чтобы посмотреть метрики.',
  'reports.loadError': 'Не удалось загрузить отчёт',
  'reports.sentTo': 'отправлен {n} получателям',
  'reports.notEmailed': 'без рассылки',
  'reports.chatsN': '{n} диал.',
  'reports.frequency.daily': 'Ежедневно',
  'reports.frequency.weekly': 'Еженедельно',
  'reports.frequency.monthly': 'Ежемесячно',
  'reports.metric.totalChats': 'Новых диалогов',
  'reports.metric.firstResponse': 'Первый ответ',
  'reports.metric.avgResponse': 'Среднее время ответа',
  'reports.metric.csat': 'CSAT',
  'reports.metric.busiest': 'Самый загруженный час',
  'reports.section.operators': 'По операторам',
  'reports.section.topTags': 'Топ-теги',
  'reports.schedule.heading': 'Плановые отчёты',
  'reports.schedule.hint': 'Периодический дайджест метрик на email + архив в этой панели.',
  'reports.schedule.enabled': 'Присылать плановый отчёт',
  'reports.schedule.frequency': 'Частота',
  'reports.schedule.recipients': 'Получатели',
  'reports.schedule.recipientsPlaceholder': 'boss@example.com\nops@example.com',
  'reports.schedule.recipientsHint': 'Один email на строку (или через запятую). Можно оставить пустым — отчёт будет только в панели.',
  'reports.schedule.timezone': 'Таймзона (для часов нагрузки)',
  'reports.schedule.saving': 'Сохранение…',
  'reports.schedule.saveError': 'Не удалось сохранить расписание',
  'reports.schedule.nextRun': 'Следующий отчёт',

  // ANX-105 — paywall-апселл при 402-лимите тарифа.
  'paywall.title': 'Лимит тарифа',
  'paywall.seat_limit_reached':
    'На текущем тарифе доступно ограниченное число операторов. Чтобы пригласить ещё, перейдите на платный тариф.',
  'paywall.dialog_limit_reached':
    'Достигнут месячный лимит диалогов на текущем тарифе. Повысьте тариф, чтобы продолжить принимать обращения.',
  'paywall.plan_required':
    'Эта возможность доступна на платных тарифах. Повысьте тариф, чтобы включить её.',
  'paywall.cta': 'Перейти к тарифам',

  // ANX-060 слой 4 — страница «Тариф и оплата».
  'billing.title': 'Тариф и оплата',
  'billing.subtitle': 'Текущий план, использование и оплата.',
  'billing.adminOnly': 'Управление тарифом доступно только администратору.',
  'billing.loadError': 'Не удалось загрузить данные о тарифе.',
  'billing.currentPlan': 'Текущий план',
  'billing.periodEnd': 'оплачено до',
  'billing.plan.free': 'Free',
  'billing.plan.pro': 'Pro',
  'billing.plan.business': 'Business',
  'billing.plan.enterprise': 'Enterprise',
  'billing.status.none': 'нет подписки',
  'billing.status.pending': 'ожидает оплаты',
  'billing.status.active': 'активна',
  'billing.status.canceled': 'отменена',
  'billing.status.pastDue': 'просрочена',
  'billing.usage.heading': 'Использование',
  'billing.usage.seats': 'Операторы',
  'billing.usage.dialogs': 'Диалоги за месяц',
  'billing.usage.unlimited': 'без лимита',
  'billing.paywall.warn':
    'Использовано {used} из {limit} диалогов за месяц — близко к лимиту тарифа Free.',
  'billing.paywall.over':
    'Лимит диалогов тарифа Free ({limit}/мес) исчерпан. Перейдите на платный тариф, чтобы снять ограничение.',
  'billing.upgradeHeading': 'Сменить тариф',
  'billing.perMonth': '/ мес',
  'billing.seats': '{n} оператор(ов)',
  'billing.seatsUnlimited': 'операторы без лимита',
  'billing.subscribeCard': 'Оформить картой',
  'billing.subscribeAria': 'Оформить картой — {plan}',
  'billing.subscribing': 'Перенаправляем…',
  'billing.subscribeError': 'Не удалось начать оплату. Попробуйте позже.',
  'billing.currentPlanBadge': 'Текущий план',
  'billing.enterpriseContact': 'Связаться',
  'billing.enterpriseAria': 'Связаться по тарифу Enterprise',
  'billing.cancelSubscription': 'Отменить подписку',
  'billing.canceling': 'Отмена…',
  'billing.cancelError': 'Не удалось отменить подписку.',
  'billing.returnPaid': 'Оплата прошла — тариф активирован.',
  'billing.returnPaidPending': 'Оплата обрабатывается. Обновите страницу через минуту.',
  'billing.returnFailed': 'Оплата не завершена. Попробуйте ещё раз.',

  // ANX-060 слой 5 — оплата по счёту (безнал РФ).
  'billing.inv.heading': 'Оплата по счёту',
  'billing.inv.hint':
    'Для юр. лиц и ИП: реквизиты плательщика, счёт и акт в PDF, оплата банковским переводом. После поступления оплаты отметьте счёт оплаченным — план активируется.',
  'billing.inv.requisitesHeading': 'Реквизиты плательщика',
  'billing.inv.kind': 'Тип',
  'billing.inv.kindLegal': 'Юр. лицо',
  'billing.inv.kindIp': 'ИП',
  'billing.inv.name': 'Наименование',
  'billing.inv.inn': 'ИНН',
  'billing.inv.kpp': 'КПП',
  'billing.inv.address': 'Юридический адрес',
  'billing.inv.email': 'Email для документов',
  'billing.inv.saveError': 'Не удалось сохранить реквизиты.',
  'billing.inv.issueHeading': 'Новый счёт',
  'billing.inv.issuePlan': 'План для счёта',
  'billing.inv.issueButton': 'Выставить счёт',
  'billing.inv.issuing': 'Выставляем…',
  'billing.inv.issueError': 'Не удалось выставить счёт.',
  'billing.inv.needRequisites': 'Сначала заполните и сохраните реквизиты плательщика.',
  'billing.inv.listHeading': 'Выставленные счета',
  'billing.inv.empty': 'Счетов пока нет.',
  'billing.inv.colNumber': '№',
  'billing.inv.colPlan': 'План',
  'billing.inv.colPeriod': 'Период',
  'billing.inv.colAmount': 'Сумма',
  'billing.inv.colStatus': 'Статус',
  'billing.inv.colActions': 'Документы',
  'billing.inv.statusIssued': 'выставлен',
  'billing.inv.statusPaid': 'оплачен',
  'billing.inv.statusCanceled': 'отменён',
  'billing.inv.downloadInvoice': 'Счёт',
  'billing.inv.downloadAct': 'Акт',
  'billing.inv.markPaid': 'Отметить оплаченным',
  'billing.inv.marking': 'Отмечаем…',
  'billing.inv.pdfError': 'Не удалось открыть PDF.',

  // ANX-087 — staff-админка продукта.
  'staff.brand': 'Anexica Admin',
  'staff.nav.dashboard': 'Дашборд',
  'staff.nav.tenants': 'Клиенты',
  'staff.nav.logout': 'Выйти',
  'staff.login.title': 'Вход в админку',
  'staff.login.email': 'Email',
  'staff.login.password': 'Пароль',
  'staff.login.signIn': 'Войти',
  'staff.login.signingIn': 'Входим…',
  'staff.login.failed': 'Неверный email или пароль.',
  'staff.login.suspended': 'Учётная запись заблокирована.',
  'staff.login.mfaPrompt': 'Подтвердите вход passkey…',
  'staff.login.enrollPrompt': 'Зарегистрируйте passkey для входа…',
  'staff.login.mfaFailed': 'Не удалось пройти passkey-проверку.',
  'staff.loadError': 'Не удалось загрузить данные.',
  'staff.actionError': 'Не удалось выполнить действие.',
  'staff.impersonating': '(под клиентом)',
  'staff.dashboard.title': 'Обзор продукта',
  'staff.dashboard.byPlan': 'По тарифам',
  'staff.metric.mrr': 'MRR',
  'staff.metric.tenants': 'Клиентов',
  'staff.metric.active': 'Активных',
  'staff.metric.suspended': 'Заблокировано',
  'staff.metric.operators': 'Операторов',
  'staff.metric.dialogs30': 'Диалогов (30д)',
  'staff.metric.new30': 'Новых (30д)',
  'staff.col.plan': 'Тариф',
  'staff.col.tenants': 'Клиентов',
  'staff.col.activeSubs': 'Активных подписок',
  'staff.col.mrrPart': 'MRR',
  'staff.col.client': 'Клиент',
  'staff.col.status': 'Статус',
  'staff.col.seats': 'Операторов',
  'staff.col.dialogsMonth': 'Диалогов/мес',
  'staff.col.created': 'Регистрация',
  'staff.tenants.search': 'Поиск по названию/slug…',
  'staff.tenants.empty': 'Клиенты не найдены.',
  'staff.status.active': 'активен',
  'staff.status.suspended': 'заблокирован',
  'staff.status.deleted': 'удалён',
  'staff.detail.back': 'К списку клиентов',
  'staff.detail.impersonate': 'Войти как клиент',
  'staff.detail.subscription': 'Подписка',
  'staff.detail.actions': 'Действия',
  'staff.detail.changePlan': 'Сменить тариф',
  'staff.detail.apply': 'Применить',
  'staff.detail.grant': 'Выдать тариф',
  'staff.detail.days': 'Дней',
  'staff.detail.grantBtn': 'Выдать',
  'staff.detail.activate': 'Разблокировать',
  'staff.detail.suspend': 'Заблокировать',
  'staff.detail.delete': 'Удалить',
  'staff.detail.deleteConfirm': 'Удалить клиента? Доступ будет закрыт (soft-delete).',
  'staff.detail.operators': 'Операторы',
  'staff.detail.noOperators': 'Операторов нет.',
  'staff.detail.invoices': 'Счета',

  'conversations.reopened': 'переоткрыт',
  'conversations.awaitingReply': 'Ждёт ответа оператора',
  'conversation.transfer.button': 'Передать',
  'conversation.transfer.selectOperator': 'Выберите коллегу…',
  'conversation.transfer.notePlaceholder': 'Причина (необязательно) — видна операторам',
  'conversation.transfer.submit': 'Передать',
  'conversation.transfer.sending': 'Передаём…',

  // MFA login modal (второй шаг после пароля)
  'auth.mfa.title': 'Подтверждение входа',
  'auth.mfa.subtitle': 'Войдите с passkey или резервным кодом',
  'auth.mfa.usePasskey': 'Войти passkey',
  'auth.mfa.useRecovery': 'Использовать резервный код',
  'auth.mfa.starting': 'Подтвердите на устройстве…',
  'auth.mfa.recoveryPrompt': 'Введите резервный код:',
  'auth.mfa.recoverySubmit': 'Войти',
  'auth.mfa.error': 'Не удалось подтвердить вход',
  'auth.mfa.invalidCode': 'Неверный или уже использованный код',

  // Forced enrollment (policy.require_mfa = true, не enrolled)
  'auth.enrollment.title': 'Требуется passkey',
  'auth.enrollment.subtitle': 'Администратор tenant включил обязательную двухфакторную аутентификацию. Зарегистрируйте passkey, чтобы продолжить.',
  'auth.enrollment.register': 'Зарегистрировать passkey',
  'auth.enrollment.registering': 'Подтвердите на устройстве…',
  'auth.enrollment.success': 'Готово — passkey зарегистрирован. Сохраните резервные коды.',
  'auth.enrollment.continue': 'Продолжить',
  'auth.enrollment.error': 'Не удалось зарегистрировать passkey',

  // Plurals — {n} автоматически подставляется
  'unread.one': '{n} непрочитанное',
  'unread.few': '{n} непрочитанных',
  'unread.many': '{n} непрочитанных',
  'unread.other': '{n} непрочитанных',
  'messages.one': '{n} сообщение',
  'messages.few': '{n} сообщения',
  'messages.many': '{n} сообщений',
  'messages.other': '{n} сообщений',
  'days.one': '{n} день',
  'days.few': '{n} дня',
  'days.many': '{n} дней',
  'days.other': '{n} дней',

  // ANX-045 — audit-log UI
  'audit.title': 'Журнал аудита',
  'audit.adminOnly': 'Доступ только для администраторов tenant’а.',
  'audit.filter.action': 'Тип события',
  'audit.filter.all': 'Все события',
  'audit.col.when': 'Время',
  'audit.col.action': 'Событие',
  'audit.col.actor': 'Кто',
  'audit.col.target': 'Объект',
  'audit.col.metadata': 'Контекст',
  'audit.actor.system': 'система',
  'audit.actor.visitor': 'visitor',
  'audit.metadata.expand': 'показать JSON',
  'audit.empty': 'Записей нет',
  'audit.loadError': 'Не удалось загрузить журнал',
  'audit.prev': 'Назад',
  'audit.next': 'Дальше',
  'audit.event.site.created': 'Создан сайт',
  'audit.event.site.updated': 'Обновлены настройки сайта',
  'audit.event.site.deleted': 'Удалён сайт',
  'audit.event.operator.passkey_registered': 'Оператор зарегистрировал passkey',
  'audit.event.operator.passkey_deleted': 'Оператор удалил passkey',
  'audit.event.operator.mfa_reset_by_admin': 'Админ сбросил MFA оператору',
  'audit.event.operator.recovery_codes_regenerated': 'Перегенерация recovery-кодов',
  'audit.event.tenant.policy_require_mfa_changed': 'Изменена политика require_mfa',
  'audit.event.invitation.created': 'Создано приглашение',
  'audit.event.invitation.accepted': 'Принято приглашение',
  'audit.event.webhook.created': 'Создан webhook',
  'audit.event.webhook.updated': 'Обновлён webhook',
  'audit.event.webhook.deleted': 'Удалён webhook',
  'audit.event.conversation.closed': 'Закрыт диалог',
  'audit.event.visitor.erasure_requested': 'Запрос на удаление PII visitor’а',
  'audit.event.export.created': 'Создан экспорт',
  'audit.event.export.delivered': 'Экспорт выгружен',
  'audit.event.csp.violation': 'CSP-violation от браузера',

  // ANX-053 — нотификации
  'notify.newMessage': 'Новое сообщение',
  'notify.title': 'Уведомления',
  'notify.sound': 'Звук при новом сообщении',
  'notify.browser': 'Браузер-уведомление при новом сообщении',
  'notify.permissionDefault': 'Браузер ещё не запросил разрешение.',
  'notify.permissionGranted': 'Разрешено',
  'notify.permissionDenied': 'Запрещено в настройках браузера. Откройте настройки сайта в браузере, чтобы изменить.',
  'notify.permissionUnsupported': 'Браузер не поддерживает Notification API.',
  'notify.requestPermission': 'Запросить разрешение',

  // ANX-059 — desktop-приложение
  'desktop.title': 'Десктоп-приложение',
  'desktop.autostart': 'Запускать при старте системы',
  'desktop.autostartHint':
    'Приложение будет автоматически открываться в системном трее при входе в систему.',

  // ANX-044 — клавиатурные шорткаты
  'hotkeys.title': 'Клавиатурные шорткаты',
  'hotkeys.nextConversation': 'Следующий диалог',
  'hotkeys.prevConversation': 'Предыдущий диалог',
  'hotkeys.sendMessage': 'Отправить сообщение',
  'hotkeys.focusCanned': 'Открыть шаблоны ответов',
  'hotkeys.closeConversation': 'Закрыть текущий диалог',
  'hotkeys.focusSearch': 'Найти диалог',
  'hotkeys.showHelp': 'Показать список шорткатов',

  // ANX-046 — visitor bans
  'ban.button': 'Заблокировать',
  'ban.popover.title': 'Заблокировать visitor\'а',
  'ban.reason.placeholder': 'Причина (опционально)',
  'ban.cancel': 'Отмена',
  'ban.confirm': 'Заблокировать',
  'ban.saving': 'Сохраняем…',
  'ban.error': 'Не удалось заблокировать',
  'ban.ttl.1d': '24 ч',
  'ban.ttl.7d': '7 дн',
  'ban.ttl.30d': '30 дн',
  'ban.ttl.perm': 'Навсегда',
  'bans.heading': 'Заблокированные visitor\'ы',
  'bans.empty': 'Никто не заблокирован.',
  'bans.permanent': 'Навсегда',
  'bans.policy.label': 'Кто может банить',
  'bans.policy.adminOnly': 'Только admin',
  'bans.policy.anyOperator': 'Любой оператор',
  'bans.policy.hint': 'Admin может банить всегда. Operator — только если выбрано «Любой».',
  'bans.table.visitor': 'Visitor',
  'bans.table.ip': 'IP',
  'bans.table.reason': 'Причина',
  'bans.table.expiresAt': 'До',
  'bans.table.status': 'Статус',
  'bans.status.active': 'Активен',
  'bans.status.expired': 'Истёк',
  'bans.unban': 'Снять',
  'bans.unban.confirm': 'Подтвердить',

  // ANX-067 — онбординг-чеклист активации
  'activation.title': 'Настройка Anexica',
  'activation.subtitle': 'Несколько шагов, чтобы запустить чат на вашем сайте',
  'activation.progress': 'Готово {done} из {total}',
  'activation.dismiss': 'Скрыть',
  'activation.step.widget': 'Установите виджет на сайт',
  'activation.step.widget.hint': 'Виджет не обнаружен — вставьте код на свой сайт',
  'activation.step.widget.active': 'Виджет активен на {domain}',
  'activation.step.widget.activeNoDomain': 'Виджет активен',
  'activation.step.team': 'Пригласите команду',
  'activation.step.team.hint': 'Добавьте операторов, чтобы отвечать вместе',
  'activation.step.officeHours': 'Настройте часы работы',
  'activation.step.officeHours.hint': 'Покажите визитёрам, когда вы онлайн',
  'activation.step.theme': 'Настройте тему виджета',
  'activation.step.theme.hint': 'Подберите цвет и приветствие под ваш бренд',
  'activation.step.conversation': 'Получите первый диалог',
  'activation.step.conversation.hint': 'Здесь появятся обращения с вашего сайта',
  'sites.widget.detected': 'Виджет активен',
  'sites.widget.detectedOn': 'Виджет активен на {domain}',
  'sites.widget.notDetected': 'Виджет не обнаружен',
} as const;
